function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs4657"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath4667"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,512 H 512 V 0 H 0 Z",
  id: "path4665"
})));

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "custom"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg",
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
}));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4653",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4659",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4663",
    clipPath: "url(#clipPath4667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4669",
    transform: "translate(78.7056,301.9888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -29.361 C -44.66,0 -57.062,-12.402 -57.062,-27.701 v -234.318 c 0,-15.298 12.402,-27.701 27.701,-27.701 h 355.939 c 15.298,0 27.701,12.403 27.701,27.701 V -54.143 0 27.701 c 0,15.299 -12.403,27.701 -27.701,27.701 H 201.196 C 185.897,55.402 173.495,43 173.495,27.701 173.495,12.402 161.093,0 145.793,0 H 30.001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4673",
    transform: "translate(459.98,357.3901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 4.67 c 15.29,0 27.7,-12.4 27.7,-27.7 v -27.7 -54.14 -207.88 c 0,-15.3 -12.41,-27.7 -27.7,-27.7 H -54.7",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4675"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4677",
    transform: "translate(363.4502,357.3901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 70.5 h -203.45 -48.27 -48.26 V -55.4",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4679"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4681",
    transform: "translate(411.7202,356.6299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 145.639 h -48.27 -203.45 -48.27 V 71.26",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4683"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4685",
    transform: "translate(459.98,243.3936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -198.844 H -27",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4687"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4689",
    transform: "translate(411.7202,427.8901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 48.26 V -154.495",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4691"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4693",
    transform: "translate(110.5005,388.8896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 179.991",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4695"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4697",
    transform: "translate(110.5005,351.3916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 102.962",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4699"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 396.986,205.899 H 240.994 v 55.497 h 155.992 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4701"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.ad058ff8.svg";
export { ForwardRef as ReactComponent };